export enum SKELETON_SIZE {
    SMALL = 'small',
    MID = 'mid',
    LARGE = 'large'
}
